import { render, staticRenderFns } from "./ClientItemHeader.vue?vue&type=template&id=c80ebd54&scoped=true&"
import script from "./ClientItemHeader.vue?vue&type=script&lang=js&"
export * from "./ClientItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClientItemHeader.vue?vue&type=style&index=0&id=c80ebd54&prod&lang=scss&"
import style1 from "./ClientItemHeader.vue?vue&type=style&index=1&id=c80ebd54&prod&lang=scss&scoped=true&"
import style2 from "./ClientItemHeader.vue?vue&type=style&index=2&id=c80ebd54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80ebd54",
  null
  
)

export default component.exports